import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import RefreshIcon from "@redotech/redo-icons/refresh-cw-01.svg";
import RefreshFilledIcon from "@redotech/redo-icons/refresh-cw-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { useCapability } from "@redotech/redo-merchant-app-common/use-capability";
import { replenishmentReportHref } from "@redotech/redo-merchant-fulfillment-app/wms/replenishment-report/replenishment-report-href";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const ReplenishmentReportItem = memo(function ReplenishmentReportItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const wmsEnabled = useCapability("wms");

  if (!wmsEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: replenishmentReportHref(routes.warehouseHref, null),
      }}
      FilledIcon={RefreshFilledIcon}
      friendlyName={t("Replenishment report", {
        context:
          "order, fulfillment, claims, and warehouse operations navigation label",
      })}
      id="replenishment-report"
      UnfilledIcon={RefreshIcon}
    />
  );
});
